import Lozenge from './Lozenge'
import type { EntraStatus } from '../lib/personRows'

/** Person status badge — shared by pages/Licenses.tsx and components/ServiceLicensesTab.tsx */
export default function StatusBadge({ status, external }: { status: EntraStatus; external: boolean }) {
  if (external) return <Lozenge color="informative">External</Lozenge>
  if (status === 'enabled') return <Lozenge color="success">Active</Lozenge>
  if (status === 'disabled') return <Lozenge color="danger">Blocked</Lozenge>
  return <Lozenge color="danger">Missing in Entra</Lozenge>
}
